import { ModelSagres } from "../../model-sagres";
import { Programacao } from "./programacao";

export class AtracaoArtistica extends ModelSagres {
  IdAtracao: number;
  IdProgramacao: number;
  NmAtracao: string; 
  NmFiscalAtracao: string; 
  NmRazaoSocialRepresentante: string; 
  DtInicio: Date; 
  VlDuracaoMinutos: number; 
  VlAtracao: number; 
  CdCpfCnpjAtracaoArtistica: string; 
  CdCpfCnpjRepresentanteLegal: string; 
  FlAtracaoLocal: string; 
  VlTotal?: number;

  IdContratoNavigation: Programacao;

  tratarDadosDaAPI(): void {
    if (this.DtInicio) {
      this.DtInicio = new Date(this.DtInicio);
    }
  }
}


